import React, {useEffect} from 'react';
import QuestionnaireScreen from '../QuestionnaireScreen/QuestionnaireScreen'
import CheckProgress from '../CheckProgress/CheckProgress'
import Questionnaire from '../../stacks/questionnaire/QuestionnaireAWS'
//import Questionnaire from '../../stacks/questionnaire/QuestionnaireMock'

const QuestionnaireICAScreen = props => {

  useEffect(() => {
    async function getProgess() {
      const progress = await CheckProgress('questionnaire')
      if (progress === false) {
          props.history.push('/progress');
      }
    }
    getProgess()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])


  const dataStore = Questionnaire.getInstance()

  return (
    <QuestionnaireScreen
      product='IntroLine'
      layoutProduct='ica'
      dataStore={dataStore}
      pathBase='questionnaire'
      progresses='questionnaire'
      home='/progress'
      {...props}
    />
  )
}

export default QuestionnaireICAScreen